<template>
  <SogCard>
    <SogCardTitle :class="_class">
      {{ _title }}
    </SogCardTitle>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">

import SogCard from "@/shared/ui/SogCard.vue";
import InsuranceExportBlank, {InsuranceExportBlankStatus} from "@/shared/model/InsuranceExportBlank";
import {computed} from "vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";

interface Props {
  insuranceExportBlank: InsuranceExportBlank
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {}
)

const _title = computed(() => {
  return (props.insuranceExportBlank.insuranceNumber ? (props.insuranceExportBlank.insuranceNumber + " - ") : "") + props.insuranceExportBlank.blankNumber;
})

const _class = computed(() => {
  return (props.insuranceExportBlank.status === InsuranceExportBlankStatus.IncorrectlyFilled) ? "deleted" : "";
})

</script>

<style scoped>
.deleted {
  text-decoration: line-through;
}

</style>
